module.exports = __webpack_public_path__ + "8510c7d9c5a3c09d97254aa65c2dd42a.png";